import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DepositState {
  name: string
  isOpenDepositChannelBox: boolean
}

const initialState: DepositState = {
  name: 'deposit',
  isOpenDepositChannelBox: false,
}

const slice = createSlice({
  name: 'deposit',
  initialState,
  reducers: {
    openDepositChannelBox: (state, action: PayloadAction<void>) => {
      state.isOpenDepositChannelBox = true
    },
    closeDepositChannelBox: (state, action: PayloadAction<void>) => {
      state.isOpenDepositChannelBox = false
    },
  },
})

export const { actions } = slice
export default slice.reducer
